
export default class DeferredPromise<T,U> extends Promise<T>{

    resolve: ((value: T | PromiseLike<T>) => void) = () => {

    };
    reject: ((reason?: U) => void) = () => {

    };

    constructor(executor: (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: U) => void) => void) {

        super(executor);
    }
}

export const createDeferredPromise = <T,U>(): DeferredPromise<T,U> => {

    let promiseResolve: ((value: T | PromiseLike<T>) => void)|null = null;
    let promiseReject: ((reason?: U) => void) |null = null;
    const promise: DeferredPromise<T,U> = new DeferredPromise((resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: U) => void) => {
        promiseResolve = resolve;
        promiseReject = reject;
    })
    promise.resolve = promiseResolve!;
    promise.reject = promiseReject!;
    return promise;
}